// @flow
import { IntlProvider } from 'react-intl'
import enMessages from '../intl/en.json'
import esMessages from '../intl/fr.json'
import Config from '../Config'

export const getLocale = () => {
  let ret = window.localStorage.getItem('LOCALE')
  if (ret) {
    return ret
  }
  const language = (window.navigator.languages && window.navigator.languages[0]) ||
    window.navigator.language ||
    window.navigator.userLanguage

  // Split locales with a region code
  ret = language.toLowerCase().split(/[_-]+/)[0]

  if (ret !== 'en' || ret !== 'fr') { return 'en' } else { return ret }
}

export const isEnglish = () => {
  return getLocale() === 'en'
}

export const getFullLocale = () => {
  return getLocale() + '-CA'
}

export function localize (key: string) {
  const useLocale = Config.useLocale
  const locale = (useLocale ? getLocale() : 'en')
  const messages = locale === 'en' ? enMessages : esMessages
  const intlProvider = new IntlProvider({ locale, messages }, {})
  const { intl } = intlProvider.getChildContext()
  const { formatMessage } = intl
  if (messages[key] === undefined || messages[key] === '') {
    // hide when poe sends nothing
    return ''
  } else {
    return formatMessage({ id: key })
  }
}

export function localizeImg (key: string) {
  const locale = getLocale()
  let ret = key.replace('.svg', `_${locale}.svg`)

  return ret
}

export const toggleLang = () => {
  const current = getLocale()
  const newLang = current === 'en' ? 'fr' : 'en'
  window.localStorage.setItem('LOCALE', newLang)
  window.localStorage.removeItem('isWelcomePageShown')
  window.location.reload()
}



// WEBPACK FOOTER //
// ./src/util/Localizer.js